import React from "react"
import mobileGestures from "./../../icons/mobile-gestures.svg"
import mouseIcon from "./../../icons/mouse.svg"
const Main = (props) => {
  const { handleStart, controlsOn, bind, supportsOrientation, loaded } = props

  const handleClick = (e) => {
    const linkClicked = e.nativeEvent.target.tagName === "A"
    if (!linkClicked && loaded) {
      handleStart()
    }
  }

  // Init
  const classes = "starting-guide " + (controlsOn ? "disabled" : null)
  const start = loaded ? (
    <div className="click">Начать</div>
  ) : (
    <div className="wait">
      Загрузка<span>.</span>
      <span>.</span>
      <span>.</span>
    </div>
  )
  return (
    <main {...bind()} className={classes} onClick={handleClick}>
      <p>
        <a href="https://mishanikatin.com/">Миша Никатин</a>
      </p>
      <div className="intro">
        <h1>Дни одиноких людей</h1>
        <h3>
          Рефлексия на&nbsp;тему одиночества современного человека, невольно
          оказавшегося в&nbsp;режиме самоизоляции. Серия из&nbsp;четырёх работ,
          основанная на&nbsp;проекте В.&nbsp;Пивоварова 1975&nbsp;года.
        </h3>
        {!supportsOrientation && (
          <div className="desktop-gestures">
            <img src={mouseIcon} alt="mouse" className="" />
            <p>
              Используйте мышь, чтобы осмотреться.
              <br />
              Изменить масштаб можно колесиком мыши.
            </p>
          </div>
        )}
        {start}
        {supportsOrientation && (
          <img
            src={mobileGestures}
            alt="accelerometer & pinch"
            className="mobile-gestures"
          />
        )}
      </div>
      <p className="credits">
        Дизайн и разработка: <a href="https://redobureau.com/">Redo</a>
      </p>
    </main>
  )
}

export default Main
